// components/Collect/CollectForm.jsx
export default function CollectForm({
  name, setName, mobile, setMobile, accountType, openDate, previousBalance,
  recieved, setRecieved, addAmounts, presentBalance, clearExceptAccountNo, saveData, fieldsLocked
}) {
  return (
    <div>
      <input className="Collect-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Customer Name" disabled={fieldsLocked} />
      <input className="Collect-input" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Phone" />
      <input className="Collect-input" value={accountType} readOnly placeholder="Account Type" disabled={fieldsLocked} />
      <input className="Collect-input" value={openDate} readOnly placeholder="Open Date" disabled={fieldsLocked} />
      <input className="Collect-input" value={previousBalance} readOnly placeholder="Previous Balance" disabled={fieldsLocked} />
      <div className="Collect-row">
        <input className="Collect-input" value={recieved} onChange={(e) => setRecieved(e.target.value)} placeholder="Recieved" type="number" />
        <button className="Collect-btn" onClick={addAmounts}>Add</button>
      </div>
      <input className="Collect-input" value={Number(presentBalance || 0).toFixed(2)}  readOnly placeholder="Present Balance" disabled={fieldsLocked} />
      <div className="Collect-row"> 
        <button className="Collect-btn Collect-btn-clear" onClick={clearExceptAccountNo}>Clear</button>
        <button className="Collect-btn Collect-btn-save" onClick={saveData}>Save</button>
      </div>
    </div>
  );
}
